import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useParams } from 'react-router';
import type { PlanLinkDto } from '@tiffinify/contracts';
import { BtnPrimary, BtnSecondary, Card, CardTitle, Helper, LoadError, PageLoader, TaskTitle, TopBar } from '../components/ui';
import { post } from '../lib/api';
import { WhatsAppText } from '../lib/whatsapp';
import { useProfile } from '../lib/queries';

/** The customer's "My plan" page: the link, the message that carries it, and WhatsApp. */
export function PlanLink() {
  const { id = '' } = useParams();
  const profile = useProfile(id);
  const name = profile.data?.subscriber.name ?? '';
  // Asking twice gives the same link: there is one per customer.
  const q = useQuery({ queryKey: ['plan-link', id], queryFn: () => post<PlanLinkDto>(`/subscribers/${id}/plan-link`), staleTime: Infinity });
  const [copied, setCopied] = useState(false);

  const head = (
    <>
      <TopBar to={`/s/${id}`} label={name ? `Back to ${name}` : 'Back'} />
      <TaskTitle title="My plan page" sub={name ? `${name}’s own page for their meals` : 'The customer’s own page for their meals'} />
    </>
  );
  if (q.isError) return <main className="main task">{head}<LoadError what="the link" onRetry={() => void q.refetch()} /></main>;
  if (!q.data) return <main className="main task">{head}<PageLoader label="Making the link" /></main>;

  const copy = async () => {
    try { await navigator.clipboard.writeText(q.data.link); setCopied(true); setTimeout(() => setCopied(false), 2000); } catch { /* the link is on screen to copy by hand */ }
  };

  return (
    <main className="main task">
      {head}
      <Card pad>
        <CardTitle title="Their link" right={<BtnSecondary sm label={copied ? 'Copied' : 'Copy'} icon={copied ? 'check' : 'link'} onClick={() => void copy()} />} />
        <p className="plan-link-url">{q.data.link}</p>
        <Helper>They see meals left, the end date and what’s due, pay by UPI, and ask to pause a day. You confirm each pause on Today.</Helper>
      </Card>
      <Card pad>
        <CardTitle title="Message" />
        <div className="bubble"><WhatsAppText text={q.data.text} /></div>
      </Card>
      <BtnPrimary label="Open in WhatsApp" icon="chat" href={q.data.wa} />
      <p className="sub center">You tap Send in WhatsApp. Nothing goes out by itself.</p>
    </main>
  );
}
